import { render, staticRenderFns } from "./ModalStorageOrderInfo.vue?vue&type=template&id=1f3b7f24&scoped=true&"
import script from "./ModalStorageOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ModalStorageOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalStorageOrderInfo.vue?vue&type=style&index=0&id=1f3b7f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b7f24",
  null
  
)

export default component.exports